import { gql } from '../types/generated';

export const ALL_OVERRIDES = gql(`
  query allOverrides {
    sessionOverrides {
      id
      features
      matchParams
    }
    playbackOverrides {
      id
      experience
      features
      matchParams
    }
  }
`);
